import { render, staticRenderFns } from "./searchMusic.vue?vue&type=template&id=37b54b13&scoped=true&"
import script from "./searchMusic.vue?vue&type=script&lang=ts&"
export * from "./searchMusic.vue?vue&type=script&lang=ts&"
import style0 from "./searchMusic.vue?vue&type=style&index=0&id=37b54b13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b54b13",
  null
  
)

export default component.exports